import { hubService, userService, } from '@/services';
import { prependModuleName } from '@/utils/vueUtils';
import UserVM from '@/view-model/user-management/UserVM';
import { removeSeparatorDateString } from '@/utils';
import { userGetterType } from '@/vuex-store/user/getters';
import { UserPageMutations, ActionTypes, } from './types';
export const ActionTypePath = prependModuleName('userManagement/userPage', ActionTypes);
const action = {
    [ActionTypes.setPageType](context, type) {
        context.commit(UserPageMutations.SET_PAGE_TYPE, type);
    },
    [ActionTypes.resetUserDetail](context) {
        context.commit(UserPageMutations.RESET_USER_DETAIL);
    },
    async isUserIdExist(context, payload) {
        const response = await userService.isUserIdExist(payload);
        return response.data;
    },
    async [ActionTypes.getUser]({ commit }, userId) {
        try {
            const response = await userService.getUser(userId);
            commit(UserPageMutations.GET_USER_DETAIL, new UserVM(response.data));
        }
        catch (error) {
            console.log('userManagement/userPage/getUser', error);
        }
    },
    async [ActionTypes.postUser](_, payload) {
        try {
            await userService.postUser(payload);
            return {
                isSuccess: true,
            };
        }
        catch (error) {
            const message = error.response?.data.error.message ?? error.message;
            const reason = error.response?.data.error.reason ?? error.reason;
            console.log('[postUser] ', message, reason);
            return {
                isSuccess: false,
                message,
                reason,
            };
        }
    },
    async [ActionTypes.putUser]({ rootGetters }, payload) {
        try {
            const loginUserId = rootGetters['user/userId'];
            const { userId, data } = payload;
            const isMyAccount = loginUserId === userId;
            let formData = data;
            formData.resignationAt = removeSeparatorDateString(formData.resignationAt);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { telephone, useYn, ...otherFormData } = formData;
            // 본인 계정의 경우 useYn(상태) 보내면 에러
            if (isMyAccount) {
                formData = {
                    ...otherFormData,
                    telephone,
                };
            }
            // 본인 계정이 아닌 경우 전화번호 보내면 에러
            if (!isMyAccount) {
                formData = {
                    ...otherFormData,
                    useYn,
                };
            }
            await userService.putUser(userId, formData);
            return {
                isSuccess: true,
            };
        }
        catch (error) {
            const message = error.response?.data.error.message ?? error.message;
            const reason = error.response?.data.error.reason ?? error.reason;
            return {
                isSuccess: false,
                reason,
                message,
            };
        }
    },
    // 허브리스트 조회 (총판 계정일 경우)
    async getHubListByDist({ commit }, info) {
        const { hubId, hubName } = info;
        const data = await hubService.getHubs({
            pageNumber: 1,
            pageSize: 1000,
            useYn: 'Y',
        });
        const optionsModel = data.list.map(({ name, code: id }) => ({
            text: `${name}`,
            value: id,
        }))
            .sort((a, b) => a.text.localeCompare(b.text))
            .filter((option) => option.id !== hubId);
        // 허브 리스트 정렬 정책에 따라 최상단에 본인 소속 허브를 등록합니다.
        // https://www.figma.com/file/7bANCHz9CK2Pjj1eNq3WXy/%EA%B3%B5%ED%86%B5?node-id=528%3A844&t=Z15LdJvnnxUgRh3g-0
        optionsModel
            .unshift({
            text: `${hubName}`,
            value: hubId,
        });
        commit('GET_HUB_LIST', optionsModel);
    },
    // 허브리스트 조회
    async getHubList({ dispatch, commit, rootGetters }) {
        const hubId = rootGetters[userGetterType.hubId];
        const hubName = rootGetters[userGetterType.hubName];
        const isDistUser = rootGetters[userGetterType.isDistUser];
        if (isDistUser) {
            dispatch('getHubListByDist', {
                hubId,
                hubName,
            });
            return;
        }
        const optionsModel = [
            {
                text: `${hubName}`,
                value: hubId,
            },
        ];
        commit('GET_HUB_LIST', optionsModel);
    },
};
export default action;
